module.exports = __webpack_public_path__ + "static/media/1.ffcb9728.avif";